export const permissionReceiptMessages = {
  "permissionReceipts.title": "Permission decisions",
  "permissionReceipts.session": "Session permission decisions ({count})",
  "permissionReceipts.once": "Allowed once",
  "permissionReceipts.always": "Always allowed",
  "permissionReceipts.reject": "Rejected",
  "permissionReceipts.origin.codenomad": "Decision in CodeNomad",
  "permissionReceipts.origin.yolo": "Automatic · Yolo",
  "permissionReceipts.origin.native": "Native decision",
  "permissionReceipts.more": "Load more decisions",
  "permissionReceipts.error": "Could not load permission decisions.",
  "permissionReceipts.retry": "Retry",
}
